.color-picker {
  &__swatch {
    padding: 5px;
    background: var(--color-bg-primary);
    border-radius: var(--radius-md);
    box-shadow: 0 0 0 1px var(--color-border-primary);
    display: inline-block;
    cursor: pointer;

    .color-picker__color {
      height: 24px;
      width: 24px;
      border-radius: 2px;
    }
  }
}
